import React, { Fragment } from 'react'
import { Route } from 'react-router-dom'
import LeftBar from './LeftBar'

const CreatingComponent = props => {
  return (
    <div className="steps-screen">
      <LeftBar getNavSteps={props.getNavSteps} routes={props.routes} />
      <div className="steps-screen__right-container" style={{ width: '100%' }}>
        <div className="steps-screen__top-bar ">
          <img src="/img/logo-blue.svg" className="steps-screen__top-bar-logo" alt="Trippere logo" />
        </div>
        <div className={props.contentContainerClassName && props.contentContainerClassName}>
          {props.containers.map((item, index) => {
            return <Route exact={true} key={index} path={item.path} render={item.component} />
          })}
        </div>
        {props.children && props.children}
      </div>
    </div>
  )
}

export default CreatingComponent



// WEBPACK FOOTER //
// src/components/CreatingComponent/index.js